import axios, { AxiosResponse } from 'axios';
import { PROFILE_API_BASE_URL } from '../../constants';
import { BasicHealthFormPayload } from '../../models/health';
import { X_OWNER } from '../../constants';
import { PayloadUserProfile } from '../../models/profile';
export default class HealthService {

  static async saveBasicProfileHealth(payload: PayloadUserProfile) {
    const response: AxiosResponse<any> = await axios.post(`${PROFILE_API_BASE_URL}/v1.0/profile?health=true&email=true&preference=true&tag=true&phone=true`, payload.profile, { headers: { [X_OWNER]: `${payload.owner}` } });
    return response.data;
  }
  static async updateEmail(payload: PayloadUserProfile) {
    const response: AxiosResponse<any> = await axios.patch(`${PROFILE_API_BASE_URL}/v1.0/profile/${payload.profileId}?email=true`, payload.profile, { headers: { [X_OWNER]: `${payload.owner}` } });
    return response.data;
  }
  static async updateTag(payload: PayloadUserProfile) {
    const response: AxiosResponse<any> = await axios.patch(`${PROFILE_API_BASE_URL}/v1.0/profile/${payload.profileId}?tag=true`, payload.profile, { headers: { [X_OWNER]: `${payload.owner}` } });
    return response.data;
  }
  static async editBasicProfileHealth(payload: PayloadUserProfile) {
    const { isName, isHeath, isPhone } = payload;
    const response: AxiosResponse<any> = await axios.patch(`${PROFILE_API_BASE_URL}/v1.0/profile/${payload.profileId}?health=${isHeath}&name=${isName}&phone=${isPhone}`, payload.profile, { headers: { [X_OWNER]: `${payload.owner}` } });
    return response.data;
  }

  static async saveBasicHealth(payload: BasicHealthFormPayload) {
    const { profileId, ...body } = payload;
    const response: AxiosResponse<any> = await axios.put(`${PROFILE_API_BASE_URL}/v1.0/profile/${profileId}/health`, body);
    return response.data;
  }

}